// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"600c6c96","126":"67bbdcd4","144":"ffb780fa","679":"91875679","999":"67da2ccd"}[chunkId] + ".chunk.css";
};